import React,{ useState ,useEffect} from 'react';

export default function Termsconditions()
{
    return(
        <>
    <div className="container-fluid">
            <div className="container2">
            <div className="row mt-5 mb-5" style={{minHeight: '440px'}}>
              <div className="col-md-12">
               <h1 className='mt-1 color214545 fw-bold '>Terms & Conditions</h1>
                
                <div className="row mt-3">
         <div className="col-md-12">
          <h5>Last updated on Jul 23rd 2023</h5>
          <ul className="bullets">
            
            <li className="m-b-15">
            The Website Owner, including subsidiaries and affiliates (“Website” or “Website Owner” or “we” or “us” or “our”) provides the information contained on the website or any of the pages comprising the website (“website”) to visitors (“visitors”) (cumulatively referred to as “you” or “your” hereinafter) subject to the terms and conditions set out in these website terms and conditions, the privacy policy and any other relevant terms and conditions, policies and notices which may be applicable to a specific section or module of the website.
            </li>
            <li className="m-b-15">
            Welcome to our website. If you continue to browse and use this website you are agreeing to comply with and be bound by the following terms and conditions of use, which together with our privacy policy govern Stories By Children''s relationship with you in relation to this website.
            </li>
            <li className="m-b-15">
            The term 'Stories By Children' or 'us' or 'we' refers to the owner of the website whose registered/operational office is 102 Maruthi Nilaya Shubh Enclave Bengaluru KARNATAKA 560102. The term 'you' refers to the user or viewer of our website.
            </li>

            <li className="m-b-15">
                <h5>The use of this website is subject to the following terms of use:</h5>
             <div style={{display: 'flex'}}>
               <div className='bullettext'>⚫</div>
                <div className="m-l-10">The content of the pages of this website is for your general information and use only. It is subject to change without notice.</div>
             </div>
             <div style={{display: 'flex'}}>
               <div className='bullettext'>⚫</div>
                <div className="m-l-10">Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.</div>
             </div>
             <div style={{display: 'flex'}}>
               <div className='bullettext'>⚫</div>
                <div className="m-l-10">Your use of any information or materials on this website is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services or information available through this website meet your specific requirements.
               </div>
             </div>
             <div style={{display: 'flex'}}>
               <div className='bullettext'>⚫</div>
                <div className="m-l-10">This website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.
               </div>
             </div>
             <div style={{display: 'flex'}}>
               <div className='bullettext'>⚫</div>
                <div className="m-l-10">All trademarks reproduced in this website which are not the property of, or licensed to, the operator are acknowledged on the website.

</div>
             </div>
             <div style={{display: 'flex'}}>
               <div className='bullettext'>⚫</div>
                <div className="m-l-10">Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offense.

</div>
             </div>
             <div style={{display: 'flex'}}>
               <div className='bullettext'>⚫</div>
                <div className="m-l-10">From time to time this website may also include links to other websites. These links are provided for your convenience to provide further information.

</div>
             </div>
             <div style={{display: 'flex'}}>
               <div className='bullettext'>⚫</div>
                <div className="m-l-10">You may not create a link to this website from another website or document without Stories By Children’s prior written consent.

</div>
             </div>
             <div style={{display: 'flex'}}>
               <div className='bullettext'>⚫</div>
                <div className="m-l-10">Your use of this website and any dispute arising out of such use of the website is subject to the laws of India or other regulatory authority.

</div>
             </div>
             <br/>
             <p>We as a merchant shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any Transaction, on Account of the Cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time

</p>
               
            </li><br/>

          

          </ul>
       
         </div>
       
        </div>
                </div>
              </div>
            </div>
         </div>
        </>
    )
}